export default "__VITE_ASSET__BBnf16Rd__"